import React, {ComponentProps, ReactNode} from 'react';
import cn from 'classnames';

import styles from './IconButton.module.scss';

export interface IIconButtonProps extends ComponentProps<'button'> {
    icon: ReactNode,
    title: string,
    text?: string,
    disabled?: boolean
}

const IconButton: React.FC<IIconButtonProps> = ({icon, title, text, className, disabled, type = 'button', ...rest}) => {

    return (
        <button
            className={cn(
                styles.icon_button,
                className,
                disabled && styles.disabledButton,
            )}
            {...rest}
            type={type}
            disabled={disabled}
        >
            <span title={title}>{icon}</span>
            {
                text && <span className={styles['text']}>{text}</span>
            }
        </button>
    );
};

export default IconButton;